import { Home, Notifications as NotificationsIcon } from "@mui/icons-material";
import ForumIcon from "@mui/icons-material/Forum";
import MenuIcon from "@mui/icons-material/Menu";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import {
  AppBar,
  Avatar,
  Badge,
  Box,
  Button,
  Chip,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  InputBase,
  styled,
  Stack,
  Toolbar,
  Typography,
  Backdrop,
  CircularProgress
} from "@mui/material";
import { Search as SearchIcon } from "@mui/icons-material";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Getrequestcall } from "../../request/Getrequest";
import {
  GET_DASHBOARD_NOTIFICATION_COUNT,
  GET_DASHBOARD_NOTIFICATION_COUNT_BY_USER_ID,
  UPDATE_CLIENT_EMPLOYEES_INFO,
  CLIENT_USE_LICENSES,
  CLIENT_DETAILS_BY_USERID_NEW,
  LOGOUT,
  GET_CLIENT_EMPLOYEE_APPS_LICENSES_DETAILS
} from "../../constant/Apipath";
import { BIWhite } from "../../assets/helpers";
// import { useNotification } from "../../connect/coman/NotificationProvider";
import BuildIdEvent, { BuildIdClientEventListener } from "../../common/BuildIdEvent";
import SignalR from "../../common/SignalR";
import { HubConnectionState } from "@microsoft/signalr";
import ProfileMenu from "../../user/main-layout/header/ProfileMenu";
import ClientInvitation from "../invitation/ClientInvitation";
import {
  setLogout,
  setSelectedClientdata,
  setLogindata,
  setClientChatCount,
  setNoLicenseAccess,
  setLicences,
  setSelectedAppPermissions
} from "../../redux/actions/actions";
import { useDispatch } from "react-redux";
import { ClientEnglishFallback } from "../constant/ClientEnglishFallback";
import { Postrequestcall } from "../../request/Postrequest";
import { getClientList } from "../../user/login/userService";
import { clearIndexDB } from "../../db";
import { fetchClientEmployeeAppsLicensesDetails, normalizeClientEmployeeAppsLicensesResponse } from "../utils/clientEmployeeAppsLicenses";

const drawerWidth = 240;

// ... (Search, SearchIconWrapper, StyledInputBase definitions remain same) ...
const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: "white",
  color: "#8D8D8D",
  marginRight: theme.spacing(2),
  marginLeft: 0,
  width: "100%",
  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(3),
    width: "auto"
  }
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      height: "19px"
    }
  }
}));

function ClientHeader({ setMobileSidebar }) {
  const { selectedClientData, loginData, multiLanguageData, clientChatCount } = useSelector(
    (state) => state?.main
  );
  const navigate = useNavigate();
  const { clientLicenses } = useSelector((state) => state?.main);
  const isMountedRef = React.useRef(true);
  const abortControllerRef = React.useRef(null);

  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorProfileEl, setAnchorProfileEl] = useState(null);
  const [currentClient, setCurrentClient] = useState("");
  const [dashboardNotificationCount, setDashboardNotificationCount] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const location = useLocation();
  const { id } = useParams();
  const open = Boolean(anchorEl);
  const DEBOUNCE_DELAY = 500; // ms
  // const { unreadCLientMsgCount } = useNotification();
  const [menuView, setMenView] = useState(false);
  const [shouldShow, setShouldShow] = useState(false);
  const dispatch = useDispatch();
  const [showInvitation, setShowinvitation] = useState(false);
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const [unreadCountsMap, setUnreadCountsMap] = useState({}); // Map of ChatGroupId -> Count
  const userIdRef = React.useRef(null);
  const activeChatGroupIdRef = React.useRef(null);

  useEffect(() => {
    if (loginData?.userInformation?.UserId) {
      userIdRef.current = Number(loginData.userInformation.UserId);
    }
  }, [loginData]);

  useEffect(() => {
    abortControllerRef.current = new AbortController();
    return () => {
      isMountedRef.current = false;
      // Cancel any pending API calls
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, []);

  const handleViewInvite = (invite) => {
    // Update Redux with selected invitation so the modal can read it
    let updatedLoginData = {
      ...loginData,
      userInformation: {
        ...loginData.userInformation,
        ClientInvitation: {
          ClientId: invite.ClientId,
          Status: 1
        }
      }
    };
    dispatch(setLogindata(updatedLoginData));
    setShowinvitation(true);
  };

  const LANGUAGE = ClientEnglishFallback?.ClientHeader(multiLanguageData?.ClientHeader || {});

  const {
    TEXT_HOME,
    TEXT_PICTURE_BOARD,
    TEXT_ACTIONS,
    TEXT_CHANGE_TRACKER,
    TEXT_COACHING,
    TEXT_COMMUNICATOR,
    TEXT_EQUIPMENT_INSPECTIONS,
    TEXT_INSPECTIONS,
    TEXT_EXPENSES,
    TEXT_SAFETY_INCIDENTS,
    TEXT_SAFETY_OBSERVATIONS,
    TEXT_SITE_ACTIVITY_REPORTS,
    TEXT_SITE_ESTIMATES,
    TEXT_SITE_FILING,
    TEXT_SUPPORT_REQUESTS,
    TEXT_TAKE5,
    TEXT_TIMESHEETS,
    TEXT_VIDEOS_TITLE,
    TEXT_QUALITY_CONTROL,
    TEXT_CLIENT_CHAT_2,
    TEXT_CLIENT_NOTIFICATIONS,
    TEXT_PLACEHOLDER_GLOBAL
  } = LANGUAGE;

  const applicationObj = {
    HOME: TEXT_HOME,
    PICTURE_BOARD: TEXT_PICTURE_BOARD,
    ACTIONS: TEXT_ACTIONS,
    CHANGE_TRACKER: TEXT_CHANGE_TRACKER,
    COACHING: TEXT_COACHING,
    COMMUNICATOR: TEXT_COMMUNICATOR,
    EQUIPMENT_INSPECTIONS: TEXT_INSPECTIONS,
    EXPENSES: TEXT_EXPENSES,
    SAFETY_INCIDENTS: TEXT_SAFETY_INCIDENTS,
    SAFETY_OBSERVATIONS: TEXT_SAFETY_OBSERVATIONS,
    SITE_ACTIVITY_REPORTS: TEXT_SITE_ACTIVITY_REPORTS,
    SITE_ESTIMATES: TEXT_SITE_ESTIMATES,
    SITE_FILLING: TEXT_SITE_FILING,
    SUPPORT_REQUESTS: TEXT_SUPPORT_REQUESTS,
    TAKE5: TEXT_TAKE5,
    TEXT_PLACEHOLDER_GLOBAL: TEXT_PLACEHOLDER_GLOBAL,
    TIMESHEETS: TEXT_TIMESHEETS,
    VIDEOS: TEXT_VIDEOS_TITLE,
    QUALITY_CONTROL: TEXT_QUALITY_CONTROL,
    CLIENT_CHAT: TEXT_CLIENT_CHAT_2,
    CLIENT_NOTIFICATIONS: TEXT_CLIENT_NOTIFICATIONS
  };

  const menuItems = [
    { btnName: "Chat", route: "chat", icon: <ForumIcon /> },
    {
      btnName: "Notifications",
      route: "client-notifications",
      icon: <NotificationsIcon />,
      badge: true
    }
  ];

  const getNotificationCount = async () => {
    try {
      const response = await Getrequestcall(
        GET_DASHBOARD_NOTIFICATION_COUNT + `${selectedClientData?.ClientEmployeeId}/`,
        loginData?.accessToken
      );
      if (response?.status === 200) {
        const data = response?.data?.data[0] ?? [];
        setDashboardNotificationCount(data);
      }
    } catch (error) {
      console.error("getNotificationCount-> Error Getting Dashboard Notification Count :: ", error);
    }
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const getUpdatedClientlist = async () => {
    try {
      let responseClientList = [];
      try {
        const detailPayload = {
          UserId: Number(loginData?.userInformation?.UserId),
          UserEmail: loginData?.userInformation?.Email
        };
        const detailRes = await Postrequestcall(
          CLIENT_DETAILS_BY_USERID_NEW,
          detailPayload,
          loginData?.accessToken
        );
        responseClientList = detailRes?.data?.Data?.ClientsList || [];
        var pendingInvitations = detailRes?.data?.Data?.ClientInvitation || [];
      } catch (error) {
        if (error.name === "CanceledError" || error.code === "ERR_CANCELED") {
          console.log("CLIENT_DETAILS_BY_USERID_NEW Request canceled");
          return; // Stop execution
        }
        console.log("CLIENT_DETAILS_BY_USERID_NEW Error:", error);
      }

      const capitalizedClientList = getClientList(responseClientList);
      let getObj = {
        ...loginData,
        userInformation: {
          ...loginData.userInformation,
          ClientsList: capitalizedClientList,
          PendingInvitations: pendingInvitations || []
        }
      };
      if (loginData?.accessToken && !abortControllerRef.current?.signal?.aborted) {
        dispatch(setLogindata(getObj));
      }
    } catch (error) { }
  };

  const handleClickProfile = async (event) => {
    setAnchorProfileEl(event?.currentTarget);
    setMenView((prev) => !prev);
    if (loginData?.accessToken) {
      await getUpdatedClientlist();
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleNavTo = (path) => {
    if (path === "/home") {
      splashScreenShow();
      return;
    } else if (path === "Home") {
      navigate(`/client/${selectedClientData?.ClientId}/home`);
      return;
    } else if (path === "search-client") {
      navigate(location.pathname, {
        state: { searchText: debouncedSearch.trim() }
      });
      return;
    }
    const formattedPath = path?.replace(/ /g, "-").toLowerCase();
    navigate(formattedPath);
  };

  const hideSearchBar = () => {
    const pathSegments = location?.pathname?.split("/")?.filter(Boolean);
    const isSiteFilingBase =
      pathSegments.length === 3 &&
      pathSegments[0] === "client" &&
      pathSegments[2] === "site-filing";

    const qualityControlIdx = pathSegments.indexOf("quality-control");
    const hasQualityControlWithId =
      qualityControlIdx !== -1 &&
      pathSegments.length > qualityControlIdx + 1 &&
      !!pathSegments[qualityControlIdx + 1];

    return (
      location.pathname.includes("home") ||
      location.pathname.includes("picture-board") ||
      location.pathname.includes("expenses") ||
      location.pathname.includes("timesheets") ||
      location.pathname.includes("actions") ||
      location.pathname.includes("equipement-inspections") ||
      isSiteFilingBase ||
      hasQualityControlWithId ||
      location.pathname.includes("take5") ||
      location.pathname.includes(`quality-control/${id}`) ||
      location.pathname.includes("chat") ||
      location.pathname.includes("inspections") ||
      location.pathname.includes("work-package")
    );
  };

  const splashScreenShow = () => {
    navigate("/home");
  };

  useEffect(() => {
    if (selectedClientData?.ClientId) {
      const selectedClientObj = loginData?.userInformation?.ClientsList?.find(
        (client) => client?.ClientId == id
      );
      setCurrentClient(selectedClientObj);
      handleCurrentClientChange("e", selectedClientObj?.OrganizationName, true);
      getInitialData();
    }
  }, []);

  const getInitialData = async () => {
    await handleSetAppLicence();
    // await getAppLicence();
  };

  const handleSetAppLicence = async () => {
    if (clientLicenses?.status === 200) {
      const hasChat = Array.isArray(clientLicenses?.data?.data)
        ? clientLicenses.data.data.some((item) => item?.AppName === "Chat")
        : false;
      if (hasChat === true) {
        setShouldShow(true);
        await getNotificationCount();
        await getClientChatUnreadCount();
      } else {
        setShouldShow(false);
      }
    }
  };

  const getClientChatUnreadCount = async () => {
    try {
      const response = await Getrequestcall(
        GET_DASHBOARD_NOTIFICATION_COUNT_BY_USER_ID + `${loginData?.userInformation?.UserId}`,
        loginData?.accessToken
      );
      if (response?.status === 200) {
        const fullData = response?.data?.data || [];
        const currentClientId = Number(selectedClientData?.ClientId);
        const currentClientData = fullData?.find((item) => item.clientId === currentClientId);

        const newMap = {};
        let total = 0;

        if (currentClientData && Array.isArray(currentClientData.data)) {
          currentClientData.data.forEach((item) => {
            const count = Number(item.messageCount) || 0;
            newMap[item.clientChatGroupId] = count;
            total += count;
          });
        }
        setUnreadCountsMap(newMap);
        dispatch(setClientChatCount(total));
        // setDashboardNotificationCount({ unReadDashboardNotification: total });
      }
    } catch (error) {
      console.error("getClientChatUnreadCount error:", error);
    }
  };

  // SignalR Listener for Chat Count
  const TAG = "ClientHeader";
  useEffect(() => {
    SignalR.connectionStatusListener((status) => {
      if (status === HubConnectionState.Connected) {
        BuildIdClientEventListener.onNewChatMessage(onNewChatMessage, TAG);
        BuildIdClientEventListener.onChatCountChange(onChatCountChange, TAG);
      }
    }, TAG);

    const handleRefresh = () => {
      getClientChatUnreadCount();
    };
    window.addEventListener("REFRESH_CLIENT_CHAT_COUNT", handleRefresh);

    const handleActiveChat = (e) => {
      const id = e.detail?.chatGroupId;
      activeChatGroupIdRef.current = id ? Number(id) : null;

      // Optimistic update: Clear unread count for this group immediately
      if (id) {
        setUnreadCountsMap((prev) => {
          const groupId = Number(id);
          // Check if we actually have unread messages to clear to avoid unnecessary re-renders
          if (!prev[groupId]) return prev;

          const newMap = { ...prev, [groupId]: 0 };
          const total = Object.values(newMap).reduce((a, b) => a + (Number(b) || 0), 0);
          dispatch(setClientChatCount(total));
          return newMap;
        });
      }
    };
    window.addEventListener("CURRENT_ACTIVE_CHAT_CHANGED", handleActiveChat);

    return () => {
      window.removeEventListener("REFRESH_CLIENT_CHAT_COUNT", handleRefresh);
      window.removeEventListener("CURRENT_ACTIVE_CHAT_CHANGED", handleActiveChat);
    };
  }, []);

  const onChatCountChange = (data) => {
    try {
      const { ChatGroupId, UnreadMessageCount } = data;
      setUnreadCountsMap((prev) => {
        // If user is currently viewing this chat, ignore updates (or set to 0)
        if (activeChatGroupIdRef.current && Number(ChatGroupId) === activeChatGroupIdRef.current) {
          return prev;
        }

        const count = Number(UnreadMessageCount) || 0;
        const newMap = { ...prev, [ChatGroupId]: count };
        const total = Object.values(newMap).reduce((a, b) => a + (Number(b) || 0), 0);
        dispatch(setClientChatCount(total));
        return newMap;
      });
    } catch (err) {
      console.log(err);
    }
  };

  const onNewChatMessage = (messages) => {
    if (!Array.isArray(messages) || messages?.length === 0) return;

    setUnreadCountsMap((prev) => {
      const newMap = { ...prev };
      const currentUserId = userIdRef.current;

      messages.forEach((msg) => {
        // Safe Parse IDs
        const msgFromId = Number(msg.fromUserId);
        const myId = Number(currentUserId);

        // Do not increment count for self-sent messages
        if (myId && msgFromId === myId) return;

        const groupId = msg.toChatGroupId;

        // Do not increment if chat is currently active
        if (activeChatGroupIdRef.current && Number(groupId) === activeChatGroupIdRef.current)
          return;

        const currentCount = Number(newMap[groupId]) || 0;
        newMap[groupId] = currentCount + 1;
      });

      const total = Object.values(newMap).reduce((a, b) => a + (Number(b) || 0), 0);
      dispatch(setClientChatCount(total));
      return newMap;
    });
  };

  const handleDrawerToggle = () => {
    setMobileSidebar((prev) => !prev);
  };

  const getCurrentTabName = () => {
    try {
      const path = location?.pathname;
      let AppName = path?.split("/")?.[3];
      AppName = AppName?.replace(/-/g, " ");
      AppName = String(AppName[0])?.toUpperCase() + String(AppName)?.slice(1) || "Home";
      const {
        HOME,
        PICTURE_BOARD,
        ACTIONS,
        CHANGE_TRACKER,
        COACHING,
        COMMUNICATOR,
        EQUIPMENT_INSPECTIONS,
        EXPENSES,
        SAFETY_INCIDENTS,
        SAFETY_OBSERVATIONS,
        SITE_ACTIVITY_REPORTS,
        SITE_ESTIMATES,
        SITE_FILLING,
        SUPPORT_REQUESTS,
        TAKE5,
        TIMESHEETS,
        VIDEOS,
        QUALITY_CONTROL,
        CLIENT_CHAT,
        CLIENT_NOTIFICATIONS
      } = applicationObj;

      switch (AppName) {
        case "Home":
          return "Home";
        case "Picture board":
          return PICTURE_BOARD;
        case "Actions":
          return ACTIONS;
        case "Change tracker":
          return CHANGE_TRACKER;
        case "Coaching":
          return COACHING;
        case "Communicator":
          return COMMUNICATOR;
        // case "Equipment inspections":
        case "Inspections":
          return EQUIPMENT_INSPECTIONS;
        case "Expenses":
          return EXPENSES;
        case "Safety incidents":
          return SAFETY_INCIDENTS;
        case "Safety observations":
          return SAFETY_OBSERVATIONS;
        case "Site activity reports":
          return SITE_ACTIVITY_REPORTS;
        case "Site estimates":
          return SITE_ESTIMATES;
        case "Site filing":
          return SITE_FILLING;
        case "Support requests":
          return SUPPORT_REQUESTS;
        case "Take5":
          return TAKE5;
        case "Timesheets":
          return TIMESHEETS;
        case "Videos":
          return VIDEOS;
        case "Quality control":
          return QUALITY_CONTROL;
        case "Client chat":
          return CLIENT_CHAT;
        case "Client notifications":
          return CLIENT_NOTIFICATIONS;
        default:
          if (AppName === "UNDEFINED") {
            return "";
          } else {
            return AppName;
          }
      }
      // return AppName == "Home" ? 0 : AppName;
    } catch (error) {
      console.log("getCurrentTabName-> Unknown Current Tav Name: ", error);
      return "Home";
    }
  };

  const handleAdminNavigate = () => {
    const webUser = import.meta.env.REACT_APP_WEB_USER || "";
    let url = "";
    if (webUser.includes("development")) {
      url = "https://bimiscwebapi-client-admin-develop.azurewebsites.net/login";
    } else if (webUser.includes("staging")) {
      url = "https://bimiscwebapi-client-admin-staging.azurewebsites.net/login";
    } else if (webUser.includes("user.mybuilderid.com")) {
      url = "https://company.mybuilderid.com/login";
    } else {
      url = "https://bimiscwebapi-client-admin-develop.azurewebsites.net/login";
    }
    window.open(`${url}?from=buildid-client`, "_blank");
  };

  const onLogout = async (e, clientName) => {
    setMenView(false);
    const deviceId = loginData?.userInformation?.DeviceId;
    setIsLoggingOut(true);
    try {
      let getLoginresponse = await Getrequestcall(`${LOGOUT}/${deviceId}`, loginData?.accessToken);
      if (getLoginresponse?.status === 200) {
        isMountedRef.current = false;
        if (abortControllerRef.current) {
          abortControllerRef.current.abort();
        }
        localStorage.setItem("ShowTradeModal", false);
        clearIndexDB();
        await dispatch(setLogout());
        handleCurrentClientChange(e, clientName);
        navigate("/");
      } else {
        setIsLoggingOut(false);
        console.log("Unexpected API Status From Logout API ");
      }
    } catch (error) {
      setIsLoggingOut(false);
      console.log("Something Weng Wrong While Logging Out :", error);
    }
  };

  const onProfile = (e, clientName) => {
    dispatch(setSelectedClientdata({}));
    dispatch(setSelectedAppPermissions([]));
    setMenView(false);
    handleCurrentClientChange(e, clientName);
    navigate("/" + loginData?.userInformation?.UserId);
  };

  const handleCurrentClientChange = async (e, name, skipApi = false) => {
    let selectedClientName;
    if (typeof name === "string") {
      selectedClientName = name;
    } else if (typeof e === "string") {
      selectedClientName = e;
    } else if (e?.target?.value) {
      selectedClientName = e.target.value;
    } else {
      selectedClientName = e;
    }

    setCurrentClient(selectedClientName);
    if (loginData?.userInformation?.ClientsList?.length > 0) {
      const filteredClients = loginData?.userInformation?.ClientsList?.filter(
        (client) => client.OrganizationName === selectedClientName
      );

      if (filteredClients.length > 0) {
        let client = filteredClients[0];
        try {
          // Call client info update (original logic)
          if (client?.ClientId !== 0 && client?.OrganizationName !== "BuildID Free") {
            await Postrequestcall(
              UPDATE_CLIENT_EMPLOYEES_INFO,
              { Id: client?.ClientEmployeeId },
              loginData?.accessToken
            );
          }

          // Call License Usage API (Added logic)
          if (client.OrganizationName !== "BuildID Free") {
            const payload = {
              ClientId: client.ClientId,
              UserId: client.UserId,
              ClientEmployeeId: client.ClientEmployeeId || client.Id,
              LicenseTypeId: client.Licenses?.[0]?.LicenseTypeId
            };
            const response = await Postrequestcall(
              CLIENT_USE_LICENSES,
              payload,
              loginData?.accessToken
            );
            const responseMessage =
              response?.data?.message ||
              response?.data?.Message ||
              response?.data?.data?.message ||
              response?.data?.data?.Message ||
              response?.message ||
              "";
            const isNoLicenseError =
              response?.status === 400 &&
              String(responseMessage).toLowerCase().includes("not enough available licenses");
            dispatch(setNoLicenseAccess(isNoLicenseError));
          } else {
            dispatch(setNoLicenseAccess(false));
          }

          // Get client employee apps and licenses details
          try {
            const clientAppsLicensesResponse = await fetchClientEmployeeAppsLicensesDetails(
              client.ClientId,
              client.ClientEmployeeId || client.Id,
              loginData?.accessToken
            );
            dispatch(
              setLicences(
                normalizeClientEmployeeAppsLicensesResponse(
                  clientAppsLicensesResponse?.response ?? clientAppsLicensesResponse
                )
              )
            );
          } catch (error) {
            console.error("Error fetching client apps licenses:", error);
            dispatch(setLicences({ status: 0, data: { data: [] } }));
          }
        } catch (error) {
          console.log("handleCurrentClientChange-> Error When Changing Current Client: ", error);
        }
        let data =
          selectedClientData?.ClientId === client?.ClientId
            ? { payload: selectedClientData }
            : setSelectedClientdata(client);

        if (!data?.payload?.hasOwnProperty("AccentColor")) {
          data.payload.AccentColor = "#B73F3A";
        }
        if (data?.payload?.AccentColor == "") {
          data.payload.AccentColor = "#B73F3A";
        }
        if (!data?.payload?.hasOwnProperty("OrganizationName")) {
          data.payload.OrganizationName = "BuildId";
        }
        dispatch(data);
      } else {
        // navigate("/home");
        // window.location.href = "/";
        // alert("Client not found");
        // dispatch(setSelectedClientdata({}));
      }
    }
    setSearchTerm("");
    setDebouncedSearch("");
  };

  const handleClientActive = (id) => {
    if (id === 0) {
      navigate("/home");
    } else navigate(`/client/${id}/home`);
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchTerm);
    }, DEBOUNCE_DELAY);

    return () => {
      clearTimeout(handler);
    };
  }, [searchTerm]);

  useEffect(() => {
    handleNavTo("search-client");
  }, [debouncedSearch]);
  useEffect(() => {
    setSearchTerm("");
  }, [location.pathname]);

  return (
    <>
      <ProfileMenu
        anchorEl={anchorProfileEl}
        setAnchorEl={setAnchorProfileEl}
        onLogout={onLogout}
        menuView={menuView}
        setMenView={setMenView}
        onProfile={onProfile}
        handleCurrentClientChange={handleCurrentClientChange}
        handleClientActive={handleClientActive}
        selectedClientData={selectedClientData}
        handleViewInvite={handleViewInvite}
      />

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button"
        }}>
        {menuItems
          .filter((item) => (shouldShow ? true : item.btnName !== "Chat"))
          .map((item, index) => (
            <MenuItem
              dense
              onClick={() => {
                handleNavTo(item.route);
                handleClose();
              }}
              key={index}>
              <ListItemIcon>
                {item.badge ? (
                  <Badge badgeContent={Number(clientChatCount) || 0} color="error">
                    {item.icon}
                  </Badge>
                ) : (
                  item.icon
                )}
              </ListItemIcon>
              <ListItemText>{item?.btnName}</ListItemText>
            </MenuItem>
          ))}
      </Menu>
      <AppBar
        position="fixed"
        sx={{
          padding: "0px 5px ",
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          ml: { sm: `${drawerWidth}px` },
          backgroundColor: selectedClientData?.AccentColor,
          boxShadow: "none",
          "% .MuiToolbar-root": {
            padding: "0px 20px"
          }
        }}>
        <Toolbar
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "0px 5px",
            position: "relative"
          }}>
          <Stack direction={"row"} gap={1}>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={() => handleDrawerToggle()}
              sx={{ display: { sm: "none" }, ml: "0px" }}>
              <MenuIcon />
            </IconButton>

            {getCurrentTabName() === "Home" ? (
              <Stack display={"flex"} flexDirection={"row"} gap={1} alignItems={"center"}>
                <Avatar
                  alt={selectedClientData?.OrganizationName ?? ""}
                  style={{ height: "32px", width: "32px" }}
                  src={selectedClientData?.ClientLogo}
                />
                <Typography
                  fontWeight={"bold"}
                  fontSize={{
                    xs: "16px",
                    sm: "16px",
                    md: "16px",
                    lg: "18px",
                    xl: "20px"
                  }}>
                  {selectedClientData?.OrganizationName}
                </Typography>
              </Stack>
            ) : (
              <Typography
                display={"flex"}
                alignItems={"center"}
                justifyContent={"center"}
                fontWeight={"bold"}
                fontSize={{
                  xs: "16px",
                  sm: "16px",
                  md: "16px",
                  lg: "18px",
                  xl: "20px"
                }}>
                {getCurrentTabName()}
              </Typography>
            )}
          </Stack>

          <Stack
            mr={0}
            display={{
              xs: "flex",
              sm: "none",
              md: "none",
              lg: "none",
              xl: "none"
            }}
            sx={{
              flexDirection: "row",
              alignItems: "center"
            }}>
            {selectedClientData?.IsAdmin == 1 && (
              <Button
                size="small"
                onClick={handleAdminNavigate}
                sx={{
                  backgroundColor: "rgba(255, 255, 255, 0.15)",
                  color: "white",
                  fontWeight: "bold",
                  border: "1px solid rgba(255, 255, 255, 0.3)",
                  backdropFilter: "blur(5px)",
                  height: "24px",
                  mr: 1,
                  fontSize: "0.65rem",
                  textTransform: "uppercase",
                  letterSpacing: "0.5px",
                  minWidth: "auto",
                  padding: "0 8px",
                  "&:hover": {
                    backgroundColor: "rgba(255, 255, 255, 0.25)",
                    border: "1px solid rgba(255, 255, 255, 0.5)"
                  }
                }}>
                Admin
              </Button>
            )}
            <Avatar
              onClick={(e) => handleClickProfile(e)}
              alt="Remy Sharp"
              style={{ height: "35px", width: "35px", cursor: "pointer" }}
              src={loginData?.pictureUrl}
            />
            <IconButton
              onClick={(e) => {
                handleClick(e);
              }}>
              <MoreVertIcon
                sx={{
                  color: "white"
                }}
              />
            </IconButton>
          </Stack>
          <Stack
            display={{
              xs: "none",
              sm: "flex",
              md: "flex",
              lg: "flex",
              xl: "flex"
            }}
            flexDirection={"row"}
            alignItems={"center"}
            gap={2}
            pr={2}>
            {hideSearchBar() ? (
              <></>
            ) : (
              <Search
                className="search-buildid"
                onKeyDown={(e) => {
                  e?.key === "Enter" && handleNavTo("search-client");
                }}>
                <SearchIconWrapper>
                  <SearchIcon color="#cccccc " />
                </SearchIconWrapper>
                <StyledInputBase
                  value={searchTerm}
                  placeholder={TEXT_PLACEHOLDER_GLOBAL}
                  inputProps={{ "aria-label": "search" }}
                  onChange={(e) => setSearchTerm(e?.target?.value)}
                  size="small"
                />
              </Search>
            )}
            {selectedClientData?.IsAdmin == 1 && (
              <Button
                size="small"
                onClick={handleAdminNavigate}
                sx={{
                  backgroundColor: "rgba(255, 255, 255, 0.15)",
                  color: "white",
                  fontWeight: "bold",
                  border: "1px solid rgba(255, 255, 255, 0.3)",
                  backdropFilter: "blur(5px)",
                  height: "24px",
                  mr: 1,
                  fontSize: "0.75rem",
                  textTransform: "uppercase",
                  letterSpacing: "0.5px",
                  minWidth: "auto",
                  padding: "0 12px",
                  "&:hover": {
                    backgroundColor: "rgba(255, 255, 255, 0.25)",
                    border: "1px solid rgba(255, 255, 255, 0.5)"
                  }
                }}>
                Admin
              </Button>
            )}
            {menuItems
              .filter((item) => (shouldShow ? true : item.btnName !== "Chat"))
              .map((item, index) => (
                <div key={index}>
                  <IconButton
                    key={index}
                    onClick={() => handleNavTo(item.route)}
                    style={{ color: BIWhite }}>
                    {item.btnName === "Chat" ? (
                      <Badge badgeContent={Number(clientChatCount) || 0} color="error">
                        {item.icon}
                      </Badge>
                    ) : item.badge ? (
                      <Badge
                        badgeContent={dashboardNotificationCount?.unReadDashboardNotification}
                        color="error">
                        {item.icon}
                      </Badge>
                    ) : (
                      item.icon
                    )}
                  </IconButton>
                </div>
              ))}

            <Avatar
              onClick={(e) => handleClickProfile(e)}
              alt="Remy Sharp"
              style={{ height: "35px", width: "35px", cursor: "pointer" }}
              src={loginData?.pictureUrl}
            />
          </Stack>
        </Toolbar>
      </AppBar>
      {showInvitation && (
        <ClientInvitation
          showInvitation={showInvitation}
          handleClose={() => setShowinvitation(false)}
        />
      )}

      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 9999,
          flexDirection: "column"
        }}
        open={isLoggingOut}>
        <CircularProgress color="inherit" />
        <Typography sx={{ mt: 2, fontSize: "16px" }}>Logging you out, please wait</Typography>
      </Backdrop>
    </>
  );
}

export default ClientHeader;
